import React from 'react';

import { observer } from 'mobx-react-lite';

import { GameSection, GameStructure, useSoundWatcher } from '@pascal/pascal-core';

import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';

import { WebGameMain } from '../game';
import { HeaderWr } from './header';
import FooterWr from './footer';
import { PayoutsAndResultsContainer } from './payoutsAndResultsContainer';
import gameLogo from '../assets/images/loading/game-logo.png';

export const WebGame = observer(() => {
  const { isSkipLobby } = gameConfigStore;
  useSoundWatcher();

  return (
    <GameStructure
      hasGameTypeLoading={isSkipLobby}
      hasLobby={isSkipLobby}
      lobbyLogoImageSrc={gameLogo}
    >
      <HeaderWr />
      <GameSection haveNotification translationValues={{}}>
        <PayoutsAndResultsContainer />
        <WebGameMain />
      </GameSection>
      <FooterWr />
    </GameStructure>
  );
});
